import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { FilmCard } from '../components/FilmCard';
import { useFilms } from '../hooks/useFilms';
import { Settings, LogOut, User as UserIcon, Loader2 } from 'lucide-react';
export function Profile() {
  const {
    user,
    isLoggedIn,
    logout
  } = useAuth();
  if (!isLoggedIn) {
    return <Navigate to="/login" data-id="element-504" />;
  }
  const {
    films,
    loading
  } = useFilms();
  const recommendations = films.slice(0, 3);
  const watchLater = films.slice(3, 5);
  return <div className="min-h-screen bg-[#0a0a0a] py-16" data-id="element-505">
      <div className="container mx-auto px-4" data-id="element-506">
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-16 border-b border-[#222] pb-10" data-id="element-507">
          <div className="flex items-center gap-8" data-id="element-508">
            <div className="w-24 h-24 bg-[#141414] text-gray-400 flex items-center justify-center border border-[#333] shadow-[0_0_20px_rgba(210,43,43,0.1)] rounded-full relative overflow-hidden" data-id="element-509">
              <div className="absolute inset-0 bg-gradient-to-tr from-[#D22B2B]/10 to-transparent" data-id="element-510"></div>
              <UserIcon className="w-10 h-10 relative z-10" data-id="element-511" />
            </div>
            <div data-id="element-512">
              <h1 className="font-noir text-4xl text-white mb-2" data-id="element-513">
                {user?.name}
              </h1>
              <p className="text-gray-500 font-serif" data-id="element-514">{user?.email}</p>
            </div>
          </div>
          <Button variant="outline" onClick={logout} className="border-[#333] text-gray-400 hover:text-white" data-id="element-515">
            <LogOut className="w-4 h-4 mr-2" data-id="element-516" />
            Выйти
          </Button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10" data-id="element-517">
          {/* Preferences Column */}
          <div className="lg:col-span-1 space-y-8" data-id="element-518">
            <Card className="bg-[#141414] border-[#222]" data-id="element-519">
              <div className="flex items-center justify-between mb-8" data-id="element-520">
                <h2 className="font-noir text-2xl text-white" data-id="element-521">Предпочтения</h2>
                <Settings className="w-5 h-5 text-gray-600" data-id="element-522" />
              </div>

              <div className="space-y-8" data-id="element-523">
                <div data-id="element-524">
                  <h3 className="font-serif text-[10px] font-bold uppercase tracking-[0.2em] text-[#D22B2B] mb-4" data-id="element-525">
                    Кто смотрит
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-526">
                    <Badge variant="default" className="bg-[#222] text-gray-300" data-id="element-527">
                      Семья
                    </Badge>
                    <Badge variant="outline" className="text-gray-500" data-id="element-528">
                      Взрослые
                    </Badge>
                  </div>
                </div>

                <div data-id="element-529">
                  <h3 className="font-serif text-[10px] font-bold uppercase tracking-[0.2em] text-[#D22B2B] mb-4" data-id="element-530">
                    Возраст
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-531">
                    {user?.preferences?.ages.map(age => <Badge key={age} variant="red" data-id="element-532">
                        {age}
                      </Badge>)}
                  </div>
                </div>

                <div data-id="element-533">
                  <h3 className="font-serif text-[10px] font-bold uppercase tracking-[0.2em] text-[#D22B2B] mb-4" data-id="element-534">
                    Любимые жанры
                  </h3>
                  <div className="flex flex-wrap gap-2" data-id="element-535">
                    {user?.preferences?.genres.map(genre => <Badge key={genre} variant="outline" className="text-gray-400 border-[#444]" data-id="element-536">
                        {genre}
                      </Badge>)}
                  </div>
                </div>

                <Button variant="secondary" size="sm" className="w-full mt-4" data-id="element-537">
                  Изменить настройки
                </Button>
              </div>
            </Card>

            <div className="bg-[#141414] p-6 border border-[#222] relative overflow-hidden" data-id="element-538">
              <div className="absolute top-0 left-0 w-1 h-full bg-[#D22B2B]" data-id="element-539"></div>
              <h3 className="font-serif text-[10px] font-bold uppercase tracking-[0.2em] text-gray-400 mb-6" data-id="element-540">
                Мои списки
              </h3>
              <ul className="space-y-1" data-id="element-541">
                <li className="flex items-center justify-between p-3 hover:bg-[#1f1f1f] cursor-pointer transition-colors group" data-id="element-542">
                  <span className="font-serif text-sm text-gray-300 group-hover:text-white" data-id="element-543">
                    Смотреть позже
                  </span>
                  <span className="text-[10px] bg-[#222] text-gray-500 px-2 py-0.5 rounded-full group-hover:text-[#D22B2B]" data-id="element-544">
                    2
                  </span>
                </li>
                <li className="flex items-center justify-between p-3 hover:bg-[#1f1f1f] cursor-pointer transition-colors group" data-id="element-545">
                  <span className="font-serif text-sm text-gray-300 group-hover:text-white" data-id="element-546">
                    Избранное
                  </span>
                  <span className="text-[10px] bg-[#222] text-gray-500 px-2 py-0.5 rounded-full group-hover:text-[#D22B2B]" data-id="element-547">
                    12
                  </span>
                </li>
                <li className="flex items-center justify-between p-3 hover:bg-[#1f1f1f] cursor-pointer transition-colors group" data-id="element-548">
                  <span className="font-serif text-sm text-gray-300 group-hover:text-white" data-id="element-549">
                    История
                  </span>
                  <span className="text-[10px] bg-[#222] text-gray-500 px-2 py-0.5 rounded-full group-hover:text-[#D22B2B]" data-id="element-550">
                    48
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Recommendations Column */}
          <div className="lg:col-span-2 space-y-16" data-id="element-551">
            {loading ? <div className="flex items-center justify-center py-20" data-id="element-552">
                <Loader2 className="w-8 h-8 text-[#D22B2B] animate-spin" data-id="element-553" />
              </div> : <>
                <section data-id="element-554">
                  <h2 className="font-noir text-3xl text-white mb-8 flex items-center gap-4" data-id="element-555">
                    <span className="w-12 h-[1px] bg-[#D22B2B]" data-id="element-556"></span>
                    Рекомендовано вам
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-557">
                    {recommendations.map((film, idx) => <div key={film.id} className="flex flex-col gap-3" data-id="element-558">
                        <div className="text-[10px] font-serif italic text-gray-500 pl-1 border-l border-[#D22B2B]" data-id="element-559">
                          "Потому что вы смотрели драмы 60-х"
                        </div>
                        <FilmCard film={film} index={idx} data-id="element-560" />
                      </div>)}
                  </div>
                </section>

                <section data-id="element-561">
                  <h2 className="font-noir text-3xl text-white mb-8 flex items-center gap-4" data-id="element-562">
                    <span className="w-12 h-[1px] bg-[#333]" data-id="element-563"></span>
                    Смотреть позже
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-564">
                    {watchLater.map((film, idx) => <FilmCard key={film.id} film={film} index={idx} data-id="element-565" />)}
                  </div>
                </section>
              </>}
          </div>
        </div>
      </div>
    </div>;
}